// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"afc67a6649a0c575","src_app_bulk-user-update_bulk-user-update_module_ts":"f6221114dba665de"}[chunkId] + ".js";
};